import { render, staticRenderFns } from "./ValidarEliminarDespacho.vue?vue&type=template&id=45f804f4&scoped=true"
import script from "./ValidarEliminarDespacho.vue?vue&type=script&lang=js"
export * from "./ValidarEliminarDespacho.vue?vue&type=script&lang=js"
import style0 from "./ValidarEliminarDespacho.vue?vue&type=style&index=0&id=45f804f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f804f4",
  null
  
)

export default component.exports